import Loader from "../../components/Loader";
import React, { useMemo } from "react";
import Roots from "./Roots";
import Section from "../../components/Section";
import usePage from "../utils/usePage";
import HomeSlider from "../../components/HomeSlider/HomeSlider";
import { get } from "lodash";

// import Last from "./Last";

// import SectionTitle from "../../components/SectionTitle";

const HomePage = (props) => {
  const data = usePage("home", {}, false);
  const stickyNotesPage = usePage("stickyNodes", {}, false);
  const stickyNotes = useMemo(
    () => get(stickyNotesPage, "sticky_nodes", []),
    [stickyNotesPage],
  );
  if (data === false || stickyNotes === false) {
    return <Loader />;
  }
  return (
    <>
      <Section className="pt-0 pb-4 no-padding-horizontal">
        <HomeSlider slides={stickyNotes} />
      </Section>
      <Section className="pt-4 pb-4">
        <Roots roots={data.roots} />
      </Section>
      {/* <Section className="pt-5 pb-2">
        <SectionTitle title="pages.home.last" />
        <Last last={data.last} />
      </Section> */}

      {/* <Section className="pt-0">
        <br/>
        <Header settings={data.settings}/>
      </Section> */}
    </>
  );
};

export default HomePage;
